const supplier = () => import('../views/supplier/list/index.vue')

export default [
  {
    path: '/suppliers',
    name: 'suppliers',
    meta: {
      name: '供应商列表',
      keepAlive: true
    },
    redirect: { name: 'supplier' }
  },
  {
    path: '/supplier',
    name: 'supplier',
    meta: {
      name: '供应商列表',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "suppliers" */'../views/supplier/list/index.vue')
  },
  {
    path: '/supplier-detail/:id',
    name: 'supplier-detail',
    meta: {
      name: '供应商详情',
      parentsName: 'supplier',
      backName: 'supplier',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "suppliers" */'../views/supplier/list/detail.vue')
  },
  {
    path: '/performance-analysis',
    name: 'performance-analysis',
    meta: {
      name: '履约概览',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "analysis" */'../views/supplier/performance-analysis/index.vue')
  }
]
